import React, { useState } from 'react';
import { FaMicroscope } from 'react-icons/fa6';
import ActionCard from '../../Layouts/ActionCard';
import classNames from 'classnames';

interface ImageTypeSelectionProps {
  onSelect: (type: 'whole-slide' | 'tma', coreSize?: number) => void;
}

export default function ImageTypeSelection({ onSelect }: ImageTypeSelectionProps) {
  const [selectedType, setSelectedType] = useState<'whole-slide' | 'tma' | null>(null);
  const [coreSize, setCoreSize] = useState<number>(1.7);

  const handleTypeSelect = (type: 'whole-slide' | 'tma') => {
    setSelectedType(type);
    if (type === 'whole-slide') {
      onSelect(type);
    }
  };

  const handleCoreSizeSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedType === 'tma') {
      onSelect(selectedType, coreSize);
    }
  };

  const getCardStyle = (selected: boolean) => {
    return classNames({
      "border-blue-700": selected,
      "border-gray-700": !selected,
    }, "border-4 cursor-pointer")
  };

  return (
    <div className="container mx-auto p-4">
      <div className="grid grid-cols-2 gap-4">
        <ActionCard
          title="Whole Slide"
          icon={<FaMicroscope />}
          className={getCardStyle(selectedType === 'whole-slide')}
          onClick={() => handleTypeSelect('whole-slide')}
        />
        <ActionCard
          title="TMA"
          icon={<FaMicroscope />}
          className={getCardStyle(selectedType === 'tma')}
          onClick={() => handleTypeSelect('tma')}
        />
      </div>
      
      {selectedType === 'tma' && (
        <form onSubmit={handleCoreSizeSubmit} className="mt-4">
          <div className="form-control w-full max-w-xs">
            <label className="label">
              <span className="label-text">Core Size (mm)</span>
            </label>
            <input
              type="number"
              step="0.1"
              min="0.1"
              max="10"
              value={coreSize}
              onChange={(e) => setCoreSize(parseFloat(e.target.value))}
              className="input input-bordered w-full max-w-xs"
            />
          </div>
          <button type="submit" className="btn btn-primary mt-4">
            Continue
          </button>
        </form>
      )}
    </div>
  );
} 